import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '@/services/instance';

interface CurrencyRates {
  base: string;
  timestamp: number;
  date: string;
  rates: { [key: string]: number };
}

interface CurrencyState {
  rates: CurrencyRates | null;
  loading: boolean;
  error: string | null;
  lastFetched: string | null;
}

const initialState: CurrencyState = {
  rates: null,
  loading: false,
  error: null,
  lastFetched: null,
};

export const fetchCurrencyRates = createAsyncThunk(
  'currency/fetchRates',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.walletApi.get('/currency/rates');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch currency rates');
    }
  },
);

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    clearCurrencyError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencyRates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrencyRates.fulfilled, (state, action) => {
        state.loading = false;
        state.rates = action.payload;
        state.lastFetched = new Date().toISOString().split('T')[0];
      })
      .addCase(fetchCurrencyRates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearCurrencyError } = currencySlice.actions;
export default currencySlice.reducer;
